export default "__VITE_ASSET__BNrTcK59__"